import { twJoin } from "tailwind-merge";
import EventAnalytics from "~/js/utilities/EventAnalytics";
import { Button, CustomImage, useCustomContext } from "~/solidJs/shared";
import type { IStyleItem } from "~/solidJs/shared/api/StylesApi";
import { StyleContext, styleMethods } from "./NodeStyleWidget";

export const StyleListItem = (props: IStyleItem) => {
	const styleCtx = useCustomContext(StyleContext);

	const handleApplyStyle = () => {
		EventAnalytics.styles.applyStyle(styleCtx.globalId, props.value);
		styleMethods.applyStyle({ ...styleCtx, style: props });
		styleMethods.deleteItem(styleCtx);
	};

	return (
		<Button
			onClick={handleApplyStyle}
			class={twJoin(
				"flex w-full shrink-0 flex-col gap-2 rounded-lg p-2 hover:bg-interaction-white-hv",
				styleMethods.getIsStyleSelected({
					nodeUUID: styleCtx.nodeUUID,
					value: props.value
				}) && "outline outline-[1px] outline-background-violet"
			)}
		>
			<CustomImage
				containerClassName="w-[158px] rounded-lg h-32"
				class=""
				src={props.cover}
			/>

			<div class="typography-text-14-medium w-full truncate text-left text-text-primary">
				{props.name}
			</div>
		</Button>
	);
};
